import React from "react";

const DistanceIcon = ({ size = 16, className = "text-background-white" }) => {
  return (
    <span className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 16 16"
      >
        <path
          stroke="currentColor"
          strokeWidth="1.5"
          d="M3.646 6a2.333 2.333 0 1 0 0-4.667 2.333 2.333 0 0 0 0 4.667ZM11.31 10h2c.733 0 1.333.6 1.333 1.333v2c0 .734-.6 1.334-1.333 1.334h-2c-.733 0-1.333-.6-1.333-1.334v-2c0-.733.6-1.333 1.333-1.333Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M8.001 3.333h1.787c1.233 0 1.806 1.527.88 2.34l-5.327 4.66c-.927.807-.353 2.334.873 2.334h1.787"
        />
      </svg>
    </span>
  );
};

export default DistanceIcon;
